import React, { FC } from "react";
import { ActionsGroup, Dialog, DialogActions, FlatButton, RaisedButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { DialogContent } from "./styled";
import { useCloseFeatureCard } from "./useCloseFeatureCard";

export const CLOSE_FEATURE_CARD_DEFAULTS = {
  maxWidth: "34rem",
  minHeight: "0",
};

export const CloseFeatureCard: FC = () => {
  const { t } = useTranslation();
  const { message, goBack, save, dontSave } = useCloseFeatureCard();

  return (
    <Dialog
      modal
      isOpen
      onCloseRequest={goBack}
      maxWidth={CLOSE_FEATURE_CARD_DEFAULTS.maxWidth}
      minHeight={CLOSE_FEATURE_CARD_DEFAULTS.minHeight}
    >
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <ActionsGroup>
          <RaisedButton primary onClick={save}>
            {t("actions.save", { ns: "common" })}
          </RaisedButton>
          <FlatButton primary onClick={dontSave}>
            {t("closeFeatureCard.doNotSave", { ns: "dialogs" })}
          </FlatButton>
          <FlatButton onClick={goBack}>{t("actions.back", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
